import React from 'react';
import PropTypes from 'prop-types';
import { Row } from 'reactstrap';
import { ColumnData } from "./index";

const RowData = (props) => {
  const { row } = props;

  return (
    <Row>
      {
        row.map((col, index) => {
          return <ColumnData key={'ColumnData_'+index} {...col} />;
        })
      }
    </Row>
  );
};

RowData.propTypes = {
  row: PropTypes.array.isRequired
};

export default RowData;